import api from '@/api'

const state = {
  cgList: [],
}

const mutations = {
  SET_CG_LIST(state, list) {
    state.cgList = list
  },
}

const actions = {
  async getCgList({ commit }) {
    const res = await api.nodeApi.getHardwareConfigurationList()
    if (res.data && res.code === 200) {
      commit('SET_CG_LIST', res.data)
    }
  },
  getCheckedTree({ getters }, payload) {
    const checkedList = []
    for (const [, values] of getters.cgTreeMap) {
      for (const x of new Set(payload)) {
        for (const child of new Set(values)) {
          if (child.id === x) {
            checkedList.push({
              id: child.id,
              cgVersion: child.label,
              cgId: child.cgId,
              cgName: child.cgName,
            })
          }
        }
      }
    }
    return checkedList
  },
}

const getters = {
  cgTree: (state) => {
    return state.cgList.reduce((result, item) => {
      const group = result.find(g => g.id === item.cgId)
      if (group) {
        group.children.push({
          id: item.id,
          label: item.cgVersion,
          cgId: item.cgId,
          cgName: item.cgName,
        })
      } else {
        result.push({
          id: item.cgId,
          label: item.cgName,
          children: [{
            id: item.id,
            label: item.cgVersion,
            cgId: item.cgId,
            cgName: item.cgName,
          }],
        })
      }
      return result
    }, [])
  },
  cgTreeMap: (state, getters) => {
    return new Map(getters.cgTree.map(item => [item.id, item.children]))
  },
  cgTreeList: (state, getters) => {
    return getters.cgTree.map(item => [item])
  },
  wrinkleTreeList: (state, getters) => {
    return getters.cgTree.reduce((result, item) => {
      result.push(item.children)
      return result
    }, [])
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
